'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const utils_fromEntries = require('./fromEntries.cjs.js');

const allAriaAttrs = {
  "aria-activedescendant": "ariaActiveDescendant",
  "aria-atomic": "ariaAtomic",
  "aria-autocomplete": "ariaAutoComplete",
  "aria-busy": "ariaBusy",
  "aria-checked": "ariaChecked",
  "aria-colcount": "ariaColCount",
  "aria-colindex": "ariaColIndex",
  "aria-colspan": "ariaColSpan",
  "aria-controls": "ariaControls",
  "aria-current": "ariaCurrent",
  "aria-describedby": "ariaDescribedBy",
  "aria-details": "ariaDetails",
  "aria-disabled": "ariaDisabled",
  "aria-dropeffect": "ariaDropEffect",
  "aria-errormessage": "ariaErrorMessage",
  "aria-expanded": "ariaExpanded",
  "aria-flowto": "ariaFlowTo",
  "aria-grabbed": "ariaGrabbed",
  "aria-haspopup": "ariaHasPopup",
  "aria-hidden": "ariaHidden",
  "aria-invalid": "ariaInvalid",
  "aria-keyshortcuts": "ariaKeyShortcuts",
  "aria-label": "ariaLabel",
  "aria-labelledby": "ariaLabelledBy",
  "aria-level": "ariaLevel",
  "aria-live": "ariaLive",
  "aria-modal": "ariaModal",
  "aria-multiline": "ariaMultiline",
  "aria-multiselectable": "ariaMultiselectable",
  "aria-orientation": "ariaOrientation",
  "aria-owns": "ariaOwns",
  "aria-placeholder": "ariaPlaceholder",
  "aria-posinset": "ariaPosInset",
  "aria-pressed": "ariaPressed",
  "aria-readonly": "ariaReadOnly",
  "aria-relevant": "ariaRelevant",
  "aria-required": "ariaRequired",
  "aria-roledescription": "ariaRoleDescription",
  "aria-rowcount": "ariaRowCount",
  "aria-rowindex": "ariaRowIndex",
  "aria-rowspan": "ariaRowSpan",
  "aria-selected": "ariaSelected",
  "aria-setsize": "ariaSetSize",
  "aria-sort": "ariaSort",
  "aria-valuemax": "ariaValueMax",
  "aria-valuemin": "ariaValueMin",
  "aria-valuenow": "ariaValueNow",
  "aria-valuetext": "ariaValueText"
};
const invertedAriaAttrs = utils_fromEntries.fromEntries(Object.entries(allAriaAttrs).map(([key, value]) => [value, key]));
const camelCaseAriaAttrs = (kebabCasedAttrs) => {
  return utils_fromEntries.fromEntries(Object.entries(kebabCasedAttrs).map(([key, val]) => {
    return [allAriaAttrs[key] || key, val];
  }));
};
const kebabCaseAriaAttrs = (camelCasedAttrs) => {
  return utils_fromEntries.fromEntries(Object.entries(camelCasedAttrs).map(([key, val]) => {
    return [
      invertedAriaAttrs[key] || key,
      val
    ];
  }));
};

exports.camelCaseAriaAttrs = camelCaseAriaAttrs;
exports.kebabCaseAriaAttrs = kebabCaseAriaAttrs;
//# sourceMappingURL=formatAriaAttrKeys.cjs.js.map
